<template>
  <div>
    <div class="cui__utils__heading">
      <strong>ภาพรวมรายงาน</strong>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <b-form-group label-cols-sm="3" label="เลือกวันที่" class="mb-2">
                  <b-tabs content-class="mt-3" fill>
                    <b-tab title="วัน" active>
                      <b-row>
                        <b-col cols="12" md="6">
                          <a-config-provider :locale="locale">
                            <a-date-picker v-model="form.startDate" :disabled-date="disabledStartDate"
                              format="YYYY-MM-DD" placeholder="วันที่เริ่มต้น" style="width: 100%"
                              @openChange="handleStartOpenChange" @change="setDate" />
                          </a-config-provider>
                        </b-col>
                        <b-col cols="12" md="6">
                          <a-config-provider :locale="locale">
                            <a-date-picker v-model="form.endDate" :disabled-date="disabledEndDate" format="YYYY-MM-DD"
                              placeholder="วันที่สิ้นสุด" :open="endOpen" style="width: 100%"
                              @openChange="handleEndOpenChange" @change="setDate" />
                          </a-config-provider>
                        </b-col>
                      </b-row>
                    </b-tab>
                    <b-tab title="เดือน">
                      <b-row>
                        <b-col cols="12" md="6">
                          <a-config-provider :locale="locale">
                            <a-month-picker v-model="form.startMouth" :disabled-date="disabledStartMouth"
                              format="YYYY-MM" placeholder="เดือนเริ่มต้น" style="width: 100%"
                              @openChange="handleStartMouth" @change="setMonth" />
                          </a-config-provider>
                        </b-col>
                        <b-col cols="12" md="6">
                          <a-config-provider :locale="locale">
                            <a-month-picker v-model="form.endMouth" :disabled-date="disabledEndMouth" format="YYYY-MM"
                              placeholder="เดือนสิ้นสุด" :open="endOpenMouth" style="width: 100%"
                              @openChange="handleEndMouth" @change="setMonth" />
                          </a-config-provider>
                        </b-col>
                      </b-row>
                    </b-tab>
                  </b-tabs>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-col>
                  <b-col>
                    <b-form-group label-cols-sm="12" label="พาร์ทเนอร์" class="mb-0">
                      <a-select v-model="form.operator" show-search placeholder="กรุณาเลือกข้อมูล" style="width: 100%"
                        @select="setOperator">
                        <a-select-option v-for="(item , index) in getOperator" :key="index" :value="item.id">
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                    </b-form-group>
                  </b-col>
                </b-col><br>
                <b-col cols="6" md="12" >
                  <b-col>
                      <b-form-group label-cols-sm="9">
                      <div class="d-flex flex-column justify-content-center ">
                        <a class="btn btn-primary" href="javascript: void(0);" @click="updateData()"><i
                            class="fa fa-history mr-1" /> อัพเดทข้อมูล</a>
                      </div>
                      </b-form-group>
                      <b-form-group label-cols-sm="9">
                      <div class="d-flex flex-column justify-content-center ">
                        <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                            class="fe fe-rotate-cw mr-1" /> ตรวจสอบ</a>
                      </div>
                      </b-form-group>
                  </b-col>
                </b-col>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <cui-chart-11 v-bind="sentDataCountDeposit" />
      </div>
      <div class="col-xl-4">
        <CuiChart11QR v-bind="sentDataCountDepositQR" />
      </div>
      <div class="col-xl-4">
        <sumCountDeposit v-bind="sentDataSumCountDeposit" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v1 v-bind="sentDataSumDeposit" />
      </div>
      <div class="col-xl-4">
        <CuiChart11v1QR v-bind="sentDataSumDepositQR" />
      </div>
      <div class="col-xl-4">
         <sumAmountDeposit v-bind="sentDataSumAmountDeposit" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v2 v-bind="sentDataCountWithdraw" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v3 v-bind="sentDataSumWithdraw" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v5 v-bind="sentDataProfit" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v6 v-bind="sentDataCountUserDeposit" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v7 v-bind="sentDataCountUserWithdraw" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v4 v-bind="sentDataCountUserBank" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v12 v-bind="sentDataCountWithdrawRefund" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v13 v-bind="sentDataSumWithdrawRefund" />
      </div>
      <!-- <div class="col-xl-4">
        <cui-chart-11v8 v-bind="sentDataCountUserBankDeposit" />
      </div>
      <div class="col-xl-4">
        <cui-chart-11v9 v-bind="sentDataCountUserBankWithdraw" />
      </div> -->
    </div>
    <div class="row">
      <div class="col-xl-3">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <b-form-group label-cols-sm="3" label="เลือกปี" class="mb-2">
                  <b-tabs content-class="mt-12" fill>
                    <b-tab title="ปี" active>
                      <b-row>
                        <b-col cols="12" md="12">
                          <vuejs-datepicker
                            v-model="forms.Year"
                            :format="customFormatter"
                            placeholder="ปี"
                            minimum-view="year"
                            name="datepicker"
                            id="input-id-start"
                            @input="setYear"
                            input-class="input-class">
                          </vuejs-datepicker>
                        </b-col>
                      </b-row>
                    </b-tab>
                  </b-tabs>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
          <h5>
            <strong>ข้อมูลการเติมเงินรายปี </strong>
          </h5>
          <canvas id="areaDataSumDeposit"></canvas>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
          <h5>
            <strong>ข้อมูลการถอนเงินรายปี</strong>
          </h5>
          <div>
            <canvas id="areaDataSumWithdraw"></canvas>
          </div>
        </div>
      </div>
    </div><br>
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
          <h5>
            <strong>ข้อมูลการเติมเงิน-ถอนเงินรายปี</strong>
          </h5>
          <div>
            <canvas id="areaDataSumProfit"></canvas>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
          <h5>
            <strong>ข้อมูลการเพิ่มบัญชีรายปี</strong>
          </h5>
          <div>
            <canvas id="areaDataCountUser"></canvas>
          </div>
        </div>
      </div>
    </div>
    <a-modal title="อัพเดทข้อมูล" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk"
        @cancel="handleCancel">
        <a-form-model ref="ruleForm" :model="formUpdate" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
          <a-form-model-item label="วันที่" prop="date">
            <a-date-picker v-model="formUpdate.date" format="YYYY-MM-DD" placeholder="วันที่" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item label="คู่ค้า" prop="operatorCode">
            <a-select v-model="formUpdate.operatorCode" placeholder="เลือกพาร์ทเนอร์">
              <a-select-option value="">
                  เลือกพาร์ทเนอร์
              </a-select-option>
              <a-select-option v-for="(item , index) in getOperator" :key="index" :value="item.operatorCode">
                  {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
  </div>
</template>
<script>
import vuejsDatepicker from 'vuejs-datepicker'
import Chart from 'chart.js'
import apiClient from '@/services/api'
import Swal from 'sweetalert2'
import CuiChart11 from './countDeposit.vue'
import CuiChart11v1 from './sumDeposit.vue'
import CuiChart11QR from './countDepositQR.vue'
import CuiChart11v1QR from './sumDepositQR.vue'
import sumCountDeposit from './sumCountDeposit.vue'
import sumAmountDeposit from './sumAmountDeposit.vue'
import CuiChart11v2 from './countWithdraw.vue'
import CuiChart11v3 from './sumWithdraw.vue'
import CuiChart11v4 from './countUserBank.vue'
import CuiChart11v5 from './profit.vue'
import CuiChart11v6 from './countUserDeposit.vue'
import CuiChart11v7 from './countUserWithdraw.vue'
// import CuiChart11v10 from './countWithdrawCom.vue'
// import CuiChart11v11 from './sumWithdrawCom.vue'
import CuiChart11v12 from './countWithdrawRefund.vue'
import CuiChart11v13 from './sumWithdrawRefund.vue'
// import CuiChart11v8 from './countUserBankDeposit.vue'
// import CuiChart11v9 from './countUserBankWithdraw.vue'
// import enUS from 'ant-design-vue/es/locale/en_US'
import thTH from 'ant-design-vue/es/locale/th_TH'
import moment from 'moment'
import 'moment/locale/th'
moment.locale('th')

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  components: {
    CuiChart11,
    CuiChart11v1,
    CuiChart11QR,
    CuiChart11v1QR,
    sumCountDeposit,
    sumAmountDeposit,
    CuiChart11v2,
    CuiChart11v3,
    CuiChart11v4,
    CuiChart11v5,
    CuiChart11v6,
    CuiChart11v7,
    // CuiChart11v10,
    // CuiChart11v11,
    CuiChart11v12,
    CuiChart11v13,
    // CuiChart11v8,
    // CuiChart11v9,
    'vuejs-datepicker': vuejsDatepicker,
  },
  computed: {
    sentDataCountDeposit: function () {
      return {
        countTotal: this.countTotal,
      }
    },
    sentDataSumDeposit: function () {
      return {
        sumTotal: this.sumTotal,
      }
    },
    sentDataCountDepositQR: function () {
      return {
        countTotal: this.countTotalQR,
      }
    },
    sentDataSumDepositQR: function () {
      return {
        sumTotal: this.sumTotalQR,
      }
    },
    sentDataSumCountDeposit: function () {
      return {
        countTotal: this.sumCountDepositTotal,
      }
    },
    sentDataSumAmountDeposit: function () {
      return {
        sumTotal: this.sumAmountDepositTotal,
      }
    },
    sentDataCountWithdraw: function () {
      return {
        countWithdrawTotal: this.countWithdrawTotal,
      }
    },
    sentDataSumWithdraw: function () {
      return {
        sumWithdrawTotal: this.sumWithdrawTotal,
      }
    },
    sentDataCountUserBank: function () {
      return {
        countUserBankTotal: this.countUserBankTotal,
      }
    },
    sentDataProfit: function () {
      return {
        profitTotal: this.profitTotal,
        sumTotal: this.sumTotal,
        sumTotalQR: this.sumTotalQR,
        sumWithdrawTotal: this.sumWithdrawTotal,
      }
    },
    sentDataCountUserDeposit: function () {
      return {
        countTotal: this.countUserDeposit,
      }
    },
    sentDataCountUserWithdraw: function () {
      return {
        countTotal: this.countUserWithdraw,
      }
    },
    sentDataCountUserBankDeposit: function () {
      return {
        countTotal: this.countUserBankDeposit,
      }
    },
    sentDataCountUserBankWithdraw: function () {
      return {
        countTotal: this.countUserBankWithdraw,
      }
    },
    sentDataCountWithdrawCom: function () {
      return {
        countWithdrawComTotal: this.countWithdrawComTotal,
      }
    },
    sentDataSumWithdrawCom: function () {
      return {
        sumWithdrawComTotal: this.sumWithdrawComTotal,
      }
    },
    sentDataCountWithdrawRefund: function () {
      return {
        countWithdrawRefundTotal: this.countWithdrawRefundTotal,
      }
    },
    sentDataSumWithdrawRefund: function () {
      return {
        sumWithdrawRefundTotal: this.sumWithdrawRefundTotal,
      }
    },
  },
  mounted() {
    const ProfitChart = document.getElementById('areaDataSumProfit')
    this.chartProfit = new Chart(ProfitChart, this.sumProfitChartData)

    const DepositChart = document.getElementById('areaDataSumDeposit')
    this.chartDeposit = new Chart(DepositChart, this.sumDepositChartData)

    const WithdrawChart = document.getElementById('areaDataSumWithdraw')
    this.chartWithdraw = new Chart(WithdrawChart, this.sumWithdrawChartData)

    const CountUserChart = document.getElementById('areaDataCountUser')
    this.chartCountUser = new Chart(CountUserChart, this.sumCountUserChartData)
  },
  data: function () {
    return {
      locale: thTH,
      // enUS,
      thTH,
      chartDeposit: null,
      visible: false,
      formLayout: 'horizontal',
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      formUpdate: {
        date: null,
        operatorCode: '',
      },
      rules: {
        date: [
          { required: true, message: 'กรุณาวันที่' },
        ],
        operatorCode: [
          { required: true, message: 'เลือกพาร์ทเนอร์', trigger: 'blur' },
        ],
      },
      sumProfitChartData: {
        type: 'line',
        data: {
          labels: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
          datasets: [
            {
              backgroundColor: '#e5f2e5',
              borderColor: '#008000',
              borderWidth: 3,
              data: [],
              id: 'amount',
              label: 'ข้อมูลการเติมเงินรายปี',
              yAxisID: 'left',
            },
            {
              backgroundColor: '#f7d0d0',
              borderColor: '#ff0000',
              borderWidth: 3,
              data: [],
              label: 'ข้อมูลการถอนเงินรายปี',
              id: 'amount',
            },
          ],
        },
        options: {
          lineTension: 1,
          responsive: true,
          scales: {
            xAxes: [{
              ticks: {
              },
            }],
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                },
                id: 'left',
                stacked: false,
                ticks: {
                  beginAtZero: true,
                  padding: 25,
                  userCallback: function(value, index, values) {
                    value = value.toString()
                    value = value.split(/(?=(?:...)*$)/)
                    value = value.join(',')
                    return value
                  },
                },
              },
            ],
          },
          tooltips: {
            intersect: false,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label: function(tooltipItem, data) {
                var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                return parseInt(tooltipValue).toLocaleString()
              },
            }, // end callbacks:
          },
        },
      },
      sumDepositChartData: {
        type: 'line',
        data: {
          labels: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
          datasets: [
            {
              label: 'ข้อมูลการเติมเงินรายปี',
              data: [],
              backgroundColor: '#e5f2e5',
              borderColor: '#008000',
              borderWidth: 3,
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                return parseInt(tooltipValue).toLocaleString()
              },
            }, // end callbacks:
          }, //
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25,
                  userCallback: function(value, index, values) {
                    value = value.toString()
                    value = value.split(/(?=(?:...)*$)/)
                    value = value.join(',')
                    return value
                  },
                },
              },
            ],
            xAxes: [{
              ticks: {
              },
            }],
          },
        },
      },
      sumWithdrawChartData: {
        type: 'line',
        data: {
          labels: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
          datasets: [
            {
              label: 'ข้อมูลการถอนเงินรายปี',
              data: [],
              backgroundColor: '#f7d0d0',
              borderColor: '#ff0000',
              borderWidth: 3,
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                return parseInt(tooltipValue).toLocaleString()
              },
            }, // end callbacks:
          }, //
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25,
                  userCallback: function(value, index, values) {
                    value = value.toString()
                    value = value.split(/(?=(?:...)*$)/)
                    value = value.join(',')
                    return value
                  },
                },
              },
            ],
            xAxes: [{
              ticks: {
              },
            }],
          },
        },
      },
      sumCountUserChartData: {
        type: 'line',
        data: {
          labels: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
          datasets: [
            {
              label: 'ข้อมูลการเพิ่มบัญชีรายปี',
              data: [],
              backgroundColor: '#acbfec',
              borderColor: '#1317a7',
              borderWidth: 3,
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                return parseInt(tooltipValue).toLocaleString()
              },
            }, // end callbacks:
          }, //
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25,
                  userCallback: function(value, index, values) {
                    value = value.toString()
                    value = value.split(/(?=(?:...)*$)/)
                    value = value.join(',')
                    return value
                  },
                },
              },
            ],
            xAxes: [{
              ticks: {
              },
            }],
          },
        },
      },
      countTotal: 0,
      sumTotal: 0,
      countTotalQR: 0,
      sumTotalQR: 0,
      sumCountDepositTotal: 0,
      sumAmountDepositTotal: 0,
      countWithdrawTotal: 0,
      sumWithdrawTotal: 0,
      countUserBankTotal: 0,
      profitTotal: 0,
      countUserDeposit: 0,
      countUserWithdraw: 0,
      countUserBankDeposit: 0,
      countUserBankWithdraw: 0,
      countWithdrawComTotal: 0,
      sumWithdrawComTotal: 0,
      countWithdrawRefundTotal: 0,
      sumWithdrawRefundTotal: 0,
      getOperator: '',
      form: {
        setOperator: '',
        startDate: moment(),
        endDate: moment(),
        startMouth: moment(),
        endMouth: moment(),
      },
      forms: {
        Year: '',
      },
      endOpen: false,
      endOpenMouth: false,
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY')
    },
    clearSearch() {
      this.countTotal = 0
      this.sumTotal = 0
      this.countTotalQR = 0
      this.sumTotalQR = 0
      this.sumCountDepositTotal = 0
      this.sumAmountDepositTotal = 0
      this.countWithdrawTotal = 0
      this.sumWithdrawTotal = 0
      this.countUserBankTotal = 0
      this.profitTotal = 0
      this.countUserDeposit = 0
      this.countUserWithdraw = 0
      this.countUserBankDeposit = 0
      this.countUserBankWithdraw = 0
      this.countWithdrawComTotal = 0
      this.sumWithdrawComTotal = 0
      this.countWithdrawRefundTotal = 0
      this.sumWithdrawRefundTotal = 0
    },
    async getData() {
      await apiClient.get('/dashboard/getDataDashboard').then(response => {
        if (response.data.code === '000') {
          this.clearSearch()

          const setData = response.data.responseData.data[0]
          // countDeposit
          this.countTotal = setData.countDepositTotal
          // sumDeposit
          this.sumTotal = setData.sumDepositTotal
          // countDepositQR
          this.countTotalQR = setData.countDepositQRTotal
          // sumDepositQR
          this.sumTotalQR = setData.sumDepositQRTotal
          // sumCountDepositTotal
          this.sumCountDepositTotal = (parseFloat(setData.countDepositTotal) + parseFloat(setData.countDepositQRTotal))
          // sumAmountDepositTotal
          this.sumAmountDepositTotal = (parseFloat(setData.sumDepositTotal) + parseFloat(setData.sumDepositQRTotal))
          // countWithdraw
          this.countWithdrawTotal = setData.countWithdrawTotal
          // sumWithdraw
          this.sumWithdrawTotal = setData.sumWithdrawTotal
          // countUserBank
          this.countUserBankTotal = setData.countUserBankTotal
          // sumProfit
          this.profitTotal = setData.sumProfit
          // countUserDeposit
          this.countUserDeposit = setData.countUserDepositTotal
          // countUserWithdraw
          this.countUserWithdraw = setData.countUserWithdrawTotal
          // countUserBankDeposit
          this.countUserBankDeposit = setData.countUserBankDepositTotal
          // countUserBankWithdraw
          this.countUserBankWithdraw = setData.countUserBankWithdrawTotal
          // countWithdrawComTotal
          this.countWithdrawComTotal = setData.countWithdrawComTotal
          // sumWithdrawComTotal
          this.sumWithdrawComTotal = setData.sumWithdrawComTotal
          // countWithdrawRefundTotal
          this.countWithdrawRefundTotal = setData.countWithdrawRefundTotal
          // sumWithdrawRefundTotal
          this.sumWithdrawRefundTotal = setData.sumWithdrawRefundTotal
        }
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    async getDataOperator() {
      await apiClient.get('/operatorMain/getData').then(response => {
        if (response.data.code === '000') {
          this.getOperator = response.data.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    disabledStartDate(startDate) {
      const endDate = this.form.endDate
      if (!startDate || !endDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    disabledEndDate(endDate) {
      const startDate = this.form.startDate

      if (!endDate || !startDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },

    setOperator() {
      const operatorCode = this.form.operator
      this.setOperarCode(operatorCode)
      this.setOperarCodeChart(operatorCode)
    },
    disabledStartMouth(startMouth) {
      const endMouth = this.form.endMouth
      if (!startMouth || !endMouth) {
        return false
      }
      return startMouth.valueOf() > endMouth.valueOf()
    },
    disabledEndMouth(endMouth) {
      const startMouth = this.form.startMouth
      if (!endMouth || !startMouth) {
        return false
      }
      return startMouth.valueOf() > endMouth.valueOf()
    },
    handleStartMouth(open) {
      if (!open) {
        this.endOpenMouth = true
      }
    },
    handleEndMouth(open) {
      this.endOpenMouth = open
    },

    setDate() {
      const startDate = (this.form.startDate) ? this.form.startDate.locale('th').format('YYYY-MM-DD 00:00:00') : moment().locale('th').format('YYYY-MM-DD 00:00:00')
      const endDate = (this.form.endDate) ? this.form.endDate.locale('th').format('YYYY-MM-DD 23:59:59') : moment().locale('th').format('YYYY-MM-DD 23:59:59')
      this.form.startMouth = ''
      this.form.endMouth = ''
      this.setDateRank(startDate, endDate)
    },

    setMonth() {
      const startDate = (this.form.startMouth) ? this.form.startMouth.startOf('month').format('YYYY/MM/DD 00:00:00') : moment().startOf('month').format('YYYY/MM/DD 00:00:00')
      const endDate = (this.form.endMouth) ? this.form.endMouth.endOf('month').format('YYYY/MM/DD 23:59:59') : moment().endOf('month').format('YYYY/MM/DD 23:59:59')
      this.form.startDate = ''
      this.form.endDate = ''
      this.setDateRank(startDate, endDate)
    },

    setYear() {
      const Year = moment(this.forms.Year).format('YYYY')
      this.setSearchYear(Year)
    },

    async setDateRank(startDate, endDate) {
      const operatorMain = this.form.operator
      const operatorMainId = parseInt(operatorMain)
      const sentData = {
        operatorMainId,
        startDate: startDate,
        endDate: endDate,
      }

      await apiClient.put('/dashboard/getDateReport', sentData).then(response => {
        if (response.data.code === '000') {
          this.clearSearch()
          const setData = response.data.responseData.data[0]
          // countDeposit
          this.countTotal = setData.countDepositTotal !== null ? setData.countDepositTotal : 0
          // sumDeposit
          this.sumTotal = setData.sumDepositTotal !== null ? setData.sumDepositTotal : 0
          // countDepositQR
          this.countTotalQR = setData.countDepositQRTotal
          // sumDepositQR
          this.sumTotalQR = setData.sumDepositQRTotal
          // sumCountDepositTotal
          this.sumCountDepositTotal = (parseFloat(setData.countDepositTotal) + parseFloat(setData.countDepositQRTotal))
          // sumAmountDepositTotal
          this.sumAmountDepositTotal = (parseFloat(setData.sumDepositTotal) + parseFloat(setData.sumDepositQRTotal))
          // countWithdraw
          this.countWithdrawTotal = setData.countWithdrawTotal !== null ? setData.countWithdrawTotal : 0
          // sumWithdraw
          this.sumWithdrawTotal = setData.sumWithdrawTotal !== null ? setData.sumWithdrawTotal : 0
          // countUserBank
          this.countUserBankTotal = setData.countUserBankTotal !== null ? setData.countUserBankTotal : 0
          // sumProfit
          this.profitTotal = setData.sumProfit
          // countUserDeposit
          this.countUserDeposit = setData.countUserDepositTotal !== null ? setData.countUserDepositTotal : 0
          // countUserWithdraw
          this.countUserWithdraw = setData.countUserWithdrawTotal !== null ? setData.countUserWithdrawTotal : 0
          // countUserBankDeposit
          this.countUserBankDeposit = setData.countUserBankDepositTotal !== null ? setData.countUserBankDepositTotal : 0
          // countUserBankWithdraw
          this.countUserBankWithdraw = setData.countUserBankWithdrawTotal !== null ? setData.countUserBankWithdrawTotal : 0
          // countWithdrawComTotal
          this.countWithdrawComTotal = setData.countWithdrawComTotal !== null ? setData.countWithdrawComTotal : 0
          // sumWithdrawComTotal
          this.sumWithdrawComTotal = setData.sumWithdrawComTotal !== null ? setData.sumWithdrawComTotal : 0
          // countWithdrawRefundTotal
          this.countWithdrawRefundTotal = setData.countWithdrawRefundTotal !== null ? setData.countWithdrawRefundTotal : 0
          // sumWithdrawRefundTotal
          this.sumWithdrawRefundTotal = setData.sumWithdrawRefundTotal !== null ? setData.sumWithdrawRefundTotal : 0
        } else {
          this.clearSearch()
        }
      })
    },

    async setOperarCode(operatorMainId) {
      const startDate = (this.form.startDate) ? this.form.startDate.format('YYYY-MM-DD 00:00:00') : moment().format('YYYY-MM-DD 00:00:00')
      const endDate = (this.form.endDate) ? this.form.endDate.format('YYYY-MM-DD 23:59:59') : moment().format('YYYY-MM-DD 23:59:59')

      const sentData = {
        operatorMainId,
        startDate: startDate,
        endDate: endDate,
      }
      await apiClient.put('/dashboard/getDateReport', sentData).then(response => {
        if (response.data.code === '000') {
          this.clearSearch()
          const setData = response.data.responseData.data[0]
          // countDeposit
          this.countTotal = setData.countDepositTotal !== null ? setData.countDepositTotal : 0
          // sumDeposit
          this.sumTotal = setData.sumDepositTotal !== null ? setData.sumDepositTotal : 0
          // countDepositQR
          this.countTotalQR = setData.countDepositQRTotal
          // sumDepositQR
          this.sumTotalQR = setData.sumDepositQRTotal
          // sumCountDepositTotal
          this.sumCountDepositTotal = (parseFloat(setData.countDepositTotal) + parseFloat(setData.countDepositQRTotal))
          // sumAmountDepositTotal
          this.sumAmountDepositTotal = (parseFloat(setData.sumDepositTotal) + parseFloat(setData.sumDepositQRTotal))
          // countWithdraw
          this.countWithdrawTotal = setData.countWithdrawTotal !== null ? setData.countWithdrawTotal : 0
          // sumWithdraw
          this.sumWithdrawTotal = setData.sumWithdrawTotal !== null ? setData.sumWithdrawTotal : 0
          // countUserBank
          this.countUserBankTotal = setData.countUserBankTotal !== null ? setData.countUserBankTotal : 0
          // sumProfit
          this.profitTotal = setData.sumProfit
          // countUserDeposit
          this.countUserDeposit = setData.countUserDepositTotal !== null ? setData.countUserDepositTotal : 0
          // countUserWithdraw
          this.countUserWithdraw = setData.countUserWithdrawTotal !== null ? setData.countUserWithdrawTotal : 0
          // countUserBankDeposit
          this.countUserBankDeposit = setData.countUserBankDepositTotal !== null ? setData.countUserBankDepositTotal : 0
          // countUserBankWithdraw
          this.countUserBankWithdraw = setData.countUserBankWithdrawTotal !== null ? setData.countUserBankWithdrawTotal : 0
          // countWithdrawComTotal
          this.countWithdrawComTotal = setData.countWithdrawComTotal !== null ? setData.countWithdrawComTotal : 0
          // sumWithdrawComTotal
          this.sumWithdrawComTotal = setData.sumWithdrawComTotal !== null ? setData.sumWithdrawComTotal : 0
          // countWithdrawRefundTotal
          this.countWithdrawRefundTotal = setData.countWithdrawRefundTotal !== null ? setData.countWithdrawRefundTotal : 0
          // sumWithdrawRefundTotal
          this.sumWithdrawRefundTotal = setData.sumWithdrawRefundTotal !== null ? setData.sumWithdrawRefundTotal : 0
        } else {
          this.clearSearch()
        }
      })
    },
    refreshChart() {
      this.chartDeposit.update()
      this.chartProfit.update()
      this.chartWithdraw.update()
      this.chartCountUser.update()
    },
    async clearChartSearch() {
      this.sumDepositChartData.data.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.sumProfitChartData.data.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.sumProfitChartData.data.datasets[1].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.sumWithdrawChartData.data.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.sumCountUserChartData.data.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    async getDataChart() {
      await apiClient.get('/dashboard/getDataChart').then(response => {
        if (response.data.code === '000') {
          this.clearChartSearch()

          const setData = response.data.responseData.data[0]
          this.sumDepositChartData.data.datasets[0].data = setData.chartDataSumDeposit
          this.sumProfitChartData.data.datasets[0].data = setData.chartDataSumDeposit
          this.sumProfitChartData.data.datasets[1].data = setData.chartDataSumWithdraw
          this.sumWithdrawChartData.data.datasets[0].data = setData.chartDataSumWithdraw
          this.sumCountUserChartData.data.datasets[0].data = setData.chartDataCountUserBank
        } else {
          this.clearChartSearch()
        }
        this.refreshChart()
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    async setOperarCodeChart(operatorMainId) {
      await apiClient.put(`/dashboard/getDataChartId/${operatorMainId}`).then(response => {
        if (response.data.code === '000') {
          this.clearChartSearch()
          const setData = response.data.responseData.data[0]
          this.sumDepositChartData.data.datasets[0].data = setData.chartDataSumDeposit
          this.sumProfitChartData.data.datasets[0].data = setData.chartDataSumDeposit
          this.sumProfitChartData.data.datasets[1].data = setData.chartDataSumWithdraw
          this.sumWithdrawChartData.data.datasets[0].data = setData.chartDataSumWithdraw
          this.sumCountUserChartData.data.datasets[0].data = setData.chartDataCountUserBank
        } else {
          this.clearChartSearch()
        }
        this.refreshChart()
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    async setSearchYear(year) {
      const operatorMain = this.form.operator
      const operatorMainId = parseInt(operatorMain)
      const sentData = {
        year,
        operatorMainId,
      }
      await apiClient.put('/dashboard/getDataChartYear', sentData).then(response => {
        if (response.data.code === '000') {
          const setData = response.data.responseData.data[0]
          this.clearChartSearch()
          this.sumDepositChartData.data.datasets[0].data = setData.chartDataSumDeposit
          this.sumProfitChartData.data.datasets[0].data = setData.chartDataSumDeposit
          this.sumProfitChartData.data.datasets[1].data = setData.chartDataSumWithdraw
          this.sumWithdrawChartData.data.datasets[0].data = setData.chartDataSumWithdraw
          this.sumCountUserChartData.data.datasets[0].data = setData.chartDataCountUserBank
        } else {
          this.clearChartSearch()
        }

        this.refreshChart()
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    refreshData() {
      this.loading(true)
      // this.getData()
      if (this.form.startDate !== '' & this.form.endDate !== '') {
        this.setDate()
      } else {
        this.setMonth()
      }
      this.getDataOperator()
      this.getDataChart()
      this.loading(false)
    },
    clearFormUpdate() {
      this.formUpdate = {
        date: null,
        operatorCode: '',
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // Swal.fire({
          //   icon: 'info',
          //   title: 'อัพเดทข้อมูล',
          //   showCancelButton: true,
          //   confirmButtonText: 'ยืนยัน',
          //   cancelButtonText: 'ยกเลิก',
          //   // showLoaderOnConfirm: false,
          //   preConfirm: (value) => {
          //     if (value) {
          Swal.fire({
            title: 'Please Wait !',
            showConfirmButton: false,
            onOpen: function () {
              Swal.showLoading()
            },
          })
          this.formUpdate.date = moment(this.formUpdate.date).format('YYYY-MM-DD')
          apiClient.get(`report/getReportDashboardDate/${this.formUpdate.operatorCode}/${this.formUpdate.date}`, {
            headers: {
              // eslint-disable-next-line quote-props
              'token': 'j67A3PhrUADkhccf',
            },
          }).then(response => {
            if (response.data.code === '000') {
              const iconError = (response.data.code === '000') ? 'success' : 'error'
              Toast.fire({
                icon: iconError,
                title: response.data.message,
              })
              this.visible = false
              this.clearFormUpdate()
            } else {
              const iconError = (response.data.code === '000') ? 'success' : 'error'
              Toast.fire({
                icon: iconError,
                title: response.data.message,
              })
              this.visible = false
              this.clearFormUpdate()
            }
            // if (response.status !== 200) {
            //   throw new Error(response.message)
            // }
            // return response.data
          }).catch(error => {
            Swal.showValidationMessage(
                    `เกิดข้อผิดพลาด: ${error}`,
            )
          })
          //   }
          // },
          // allowOutsideClick: () => !Swal.isLoading(),
          // }).then((result) => {
          //   /* Read more about isConfirmed, isDenied below */
          //   if (result.isConfirmed) {
          //     const iconError = (result.value.code === '000') ? 'success' : 'error'
          //     Toast.fire({
          //       icon: iconError,
          //       title: result.value.message,
          //     })
          //     this.visible = false
          //     this.clearFormUpdate()
          //     this.refreshData()
          //     // this.confirmLoading = false
          //   }
          // })
        }
      })
    },
    updateData() {
      this.visible = !this.visible
    },
    handleOk(e) {
      // this.confirmLoading = true
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
      this.clearFormUpdate()
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  async created() {
    this.loading(true)
    await this.getData()
    await this.getDataOperator()
    await this.getDataChart()
    this.loading(false)
  },
}

</script>
<style>
.bg-danger {
    background-color: #f04e3f !important;
}
.bg-success {
    background-color: #14ab84 !important;
}
.bg-default {
    background-color: #f1f1f1 !important;
}
.input-class {
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  color: #595c97;
  border: 1px solid #e4e9f0;
  border-radius: 4px;
}
</style>
